import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Ticket } from "lucide-react";

/**
 * Crear/editar rifa: la app móvil tiene el flujo completo (vehículo, fechas, reglas, sorteo).
 * Desde el dashboard puedes ver y gestionar estado (activar/cancelar/sortear) en la página de detalle.
 * Para crear una rifa nueva con todos los campos, usa la app móvil (Admin → Rifas → Nueva).
 */
export function RaffleForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);

  return (
    <div className="max-w-2xl space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/raffles">
            <span className="sr-only">Volver</span>
            ←
          </Link>
        </Button>
        <h1 className="font-display text-2xl font-semibold">
          {isEdit ? "Editar rifa" : "Nueva rifa"}
        </h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Ticket className="h-5 w-5" />
            Crear o editar rifa
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            El formulario completo para crear y editar rifas (premio, fechas, reglas, precios) está en la{" "}
            <strong>app móvil</strong> (Admin → Rifas → Nueva rifa / Editar).
          </p>
          <p className="text-sm text-muted-foreground">
            Desde este dashboard puedes ver todas las rifas, activar o cancelar una rifa, ver participantes y{" "}
            <strong>realizar el sorteo</strong> cuando corresponda.
          </p>
          <Button asChild>
            <Link to="/raffles">Ver rifas</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
